import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Modal, Button, Row, Col, Tag, Icon } from 'antd';

const { CheckableTag } = Tag;
@inject('ecodeDemoStore')
@observer
class App extends React.Component {
  onCancelTag = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ visibleOfTag: false, currentTagIds: '', editTagId: '', editRecord: {}, newTagValue: '', newTagDes: '', addTags: [] });
  }
  onSubmitTag = () => {
    const { getParams, ecodeDemoStore: { submitTag, setMobxState, searchFormValue } } = this.props;
    const params = toJS(searchFormValue);
    const param = getParams(params);
    setMobxState({ pageNum: 1 });
    delete param.username;
    delete param.usermobile;
    delete param.ecodeversion;
    delete param.ecversion;
    submitTag(param);
    setMobxState({ visibleOfTag: false });
  }
  searchTagChange = (checked, id) => {
    let { ecodeDemoStore: { setMobxState, searchTagId } } = this.props;
    searchTagId = toJS(searchTagId);
    if (checked) {
      searchTagId = searchTagId.push(id)
    } else {
      searchTagId.splice(searchTagId.indexOf(id), 1);
    }
    setMobxState({ searchTagId });
  }
  showNewTag = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ visibleOfNewTag: true });
  }
  tagChange = (checked, id) => {
    let { ecodeDemoStore: { setMobxState, addTags } } = this.props;
    addTags = toJS(addTags);
    if (checked) {
      addTags.push(id.toString())
    } else {
      addTags.splice(addTags.indexOf(id.toString()), 1);
    }
    setMobxState({ addTags: addTags });
    this.forceUpdate();
  }
  render() {
    const { formPrefixCls, formItemLayout, ecodeDemoStore: { visibleOfTag, tagData, addTags } } = this.props;
    return (
      <Modal
        title={`编辑标签`}
        // className={`${prefixCls}-detailModal`}
        visible={visibleOfTag}
        onCancel={this.onCancelTag}
        width={950}
        zIndex={1000}
        footer={
          [(<Button onClick={this.onSubmitTag} type="primary" key="detailCancel">提交</Button>)]
        }
      >
        <Row className={`${formPrefixCls}-row`}>
          <Col xs={formItemLayout.labelCol.xs} sm={formItemLayout.labelCol.sm}>
            <span>标签：</span>
          </Col>
          <Col xs={formItemLayout.wrapperCol.xs} sm={formItemLayout.wrapperCol.sm}>
            {
                toJS(tagData).map(item => {
                  return (<CheckableTag key={item.id} checked={toJS(addTags).indexOf(item.id.toString()) > -1} onChange={(checked) => this.tagChange(checked, item.id)}>{item.typeName}</CheckableTag>)
                })
            }
             <Tag onClick={this.showNewTag} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" /> 自定义标签
              </Tag>
          </Col>
        </Row>
      </Modal>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/AddTag.js